<template>
    <v-card>
        <v-card-title>
            User log
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="4" style="height: 100px;">
                    <v-text-field v-model="userId" label="User ID" :rules="userIdRules" required clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-btn class="mr-4" @click="loadUserLog" align="left" :loading="loading">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="12">
                    <v-data-table
                            dense
                            :headers="headers"
                            :items="userLog"
                            :items-per-page="50"
                            :footer-props="{'items-per-page-options': [10, 20, 50, 100, -1]}"
                            :search="search"
                            :sort-by="['timestamp']"
                            :sort-desc="[false]"
                            style="white-space: nowrap"
                    >
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Users</v-toolbar-title>
                                <v-divider class="mx-2" inset vertical/>
                                <!--                    <v-btn @click="createItem" class="ma-2" color="primary">-->
                                <!--                        New User-->
                                <!--                    </v-btn>-->
                                <v-spacer/>
                                <v-text-field
                                        append-icon="search"
                                        hide-details
                                        label="Search"
                                        single-line
                                        v-model.trim="search"
                                />
                            </v-toolbar>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
        <!--        <v-product-dialog ref="product-dialog"/>-->
    </v-card>
</template>

<script>
    import dayJS from 'dayjs';
    import relativeTime from 'dayjs/plugin/relativeTime';
    import store from "../store";
    dayJS.extend(relativeTime);

    export default {
        name: "UserLog",
        data: () => ({
            search: "",
            headers: [
                { text: "Event", value: "eventType"},
                { text: "Data", value: "data"},
                { text: "Created", value: "created"},
                { text: "Timestamp", value: "timestamp"},
            ],
            userLogItems: [],
            userId: '',
            userIdRules: [
                v => !!v || 'User ID is required',
                v => (v == null || v.length > 27) || 'User ID must be more than 27 characters',
            ],
        }),
        computed: {
            loading() {
                return this.$store.state.loading;
            },
            userLog() {
                return store.getters["users/getUserLog"]
            },
        },
        methods: {
            loadUserLog() {
                if(this.userId) {
                    store.dispatch("users/loadUserLog", {
                        userId: this.userId,
                    });
                }
            },
        },
        created() {
            //this.items = []// StoreHelper.getProducts()
        }
    };
</script>